import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Modal,
  GDSStyleObject,
} from '@leagueplatform/genesis-core';
import BackToAcctMgmt from './backToAcctMgmt.component';

export function AccountManagementContainer(props: {
  buttonLabel: string;
  modalTitle: string;
  children: any;
  isOpen: boolean;
  setIsOpen: Function;
  showModal: boolean;
  hideButton: boolean;
  backToAcctMgmtControl: Function;
  submitButton?: any;
  trailingContent?: any;
}) {
  const {
    buttonLabel,
    modalTitle,
    children,
    isOpen,
    setIsOpen,
    showModal,
    hideButton,
    backToAcctMgmtControl,
    submitButton,
    trailingContent,
  } = props;

  const [browser, setBrowser] = useState<string>('');

  function myFunction() {
    if (
      (navigator.userAgent.indexOf('Opera') ||
        navigator.userAgent.indexOf('OPR')) !== -1
    ) {
      setBrowser('Opera');
    } else if (navigator.userAgent.indexOf('Edg') !== -1) {
      setBrowser('Edge');
    } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
      setBrowser('Chrome');
    } else if (navigator.userAgent.indexOf('Safari') !== -1) {
      setBrowser('Safari');
    } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
      setBrowser('Firefox');
    } else if (
      navigator.userAgent.indexOf('MSIE') !== -1 ||
      !!document.DOCUMENT_NODE === true
    ) {
      setBrowser('IE');
    } else {
      setBrowser('unknown');
    }
  }

  useEffect(() => {
    myFunction();
  }, []);

  return (
    <Modal.Root
      open={showModal || isOpen}
      data-testid="tobacco-modal"
      onOpenChange={() => setIsOpen((previous: any) => !previous)}
    >
      {hideButton ? (
        ''
      ) : (
        <Modal.Trigger>
          {
            // Change this to be the account management clickable item in the Account Management modal
          }
          <Button>{buttonLabel}</Button>
        </Modal.Trigger>
      )}
      <Modal.Content
        showCloseButton={false}
        padding={{
          '@initial': '30px 150px',
          '@laptop': '30px 100px',
          '@tablet': '30px 30px',
          '@mobile': '20px 0',
          '@mobileLandscape': '30px',
        }}
        css={
          {
            borderRadius: '12px',
            background: '#fff',
            height: '100%',
            overflowY: 'auto',
            '.GDS-modal': {
              height: ['Firefox'].includes(browser)
                ? '100% !important'
                : 'auto !important',
            },
          } as GDSStyleObject
        }
        width={{ '@initial': '65%', '@laptop': '80%', '@mobile': '100%' }}
        onInteractOutside={(e: any) => e.preventDefault()}
      >
        <Box
          css={{
            height: 'auto',
            padding: '$two $three',
            '@mobile': {
              maxWidth: '100vw',
              width: '100%',
              height: '100vh',
              overflow: 'auto !important',
            },
          }}
        >
          <BackToAcctMgmt
            customOnClick={() => {
              backToAcctMgmtControl();
            }}
          />
          {children}

          {submitButton && (
            <Box
              css={{
                margin: '$two auto $none auto',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {submitButton}
            </Box>
          )}
          {trailingContent && (
            <Box
              css={{
                marginTop: '$three',
                '@mobile': {
                  marginBottom: '$five',
                  minHeight: '200px',
                  height: 'auto',
                  overflow: 'scroll',
                },
              }}
            >
              {trailingContent}
            </Box>
          )}
        </Box>
        <Modal.Title data-testid="modal-title">{modalTitle}</Modal.Title>
      </Modal.Content>
    </Modal.Root>
  );
}
